import React from 'react';
import queryString from 'query-string';
import {
  filterIsApplied, formatFilterAmount, getCurrencySignForCode, getCurrentCurrencyCode
} from '../../config/util';
import { paramOrNul, toCamelCase } from '../../../common/config/utils';
import { readingViaFilters, numberOfReviewsFilters } from '../../config/const';
import classes from './classes.module.scss';
import ExpandedText from '../../../common/helpers/expanded_text';
import { SvgIcon } from '../../../common/sprites';

const shouldShowFilteredBy = (readingVia, minNumberOfReviewsGe, ppmLe, ppmGe, t) => {
  if (readingVia !== undefined
    || (minNumberOfReviewsGe !== undefined && minNumberOfReviewsGe !== '0')
    || ppmLe !== undefined || ppmGe !== undefined) {
    return t('filter.filtered_by');
  }
  return '';
};

export const generateFilterString = (t) => {
  const {
    minNumberOfReviewsGe, ppmGe, ppmLe, readingVia, query
  } = toCamelCase(queryString.parse(window.location.search));
  const { currency } = window.store?.getState()?.user || {};
  const filterPrice = window.store?.getState()?.application?.dynamicConfig?.localFilterPricePerMinute || {};
  const maxPrice = ppmLe || filterPrice.max;
  const minPrice = ppmGe || filterPrice.min;
  const queryValue = query !== undefined ? paramOrNul(`${ t('search') }: `, query) : null;
  const sign = getCurrencySignForCode(currency || getCurrentCurrencyCode());
  const priceRange = `${ sign }${ formatFilterAmount(minPrice) }-${ sign }${ formatFilterAmount(maxPrice) }`;
  const filters = [
    readingVia ? t(readingViaFilters[readingVia]) : null,
    minNumberOfReviewsGe !== '0' ? t(numberOfReviewsFilters[minNumberOfReviewsGe]) : null,
    !!ppmLe || !!ppmGe ? priceRange : null,
    ...Object.keys(queryValue || {}).map((key) => `${ key }${ queryValue[key] }`)
  ].filter((n) => n);
  return `${ shouldShowFilteredBy(readingVia, minNumberOfReviewsGe, ppmLe, ppmGe, t) } ${ filters.join(', ') }`;
};

export const shouldTrackCategoryEvent = ({
  requestParams, analyticEvents, location
}) => (requestParams || {}).categoryId
  && ((analyticEvents || {}).category || {})['category name']
  && (location.state || {}).trackCategoryEvent;

export const getTitleMetaTagName = ({ name, t }) =>  {
  const search = queryString.parse(window.location.search);
  const { page } = search || {};
  const title = `${ t('app_name_title') } : ${ name || 'Psychics' }`;
  if (page > 1) return `${ title } - Page ${ page }`;
  return title;
};

export const getTopGradientColor = ({ backgroundColor }) => {
  if (backgroundColor) return backgroundColor;
  return '#F5F5F5';
};

export const getPageTitleNameText = ({ name, t, h1Title }) => h1Title ?? name ?? t('all_advisors_header');

export const getLoadingPage = ({ searchPage, page, needRefresh }) => {
  if (needRefresh) return 1;
  if (searchPage) return parseFloat(searchPage);
  return page;
};

export const needRenderNoResults = ({ noResults }) => noResults && !filterIsApplied({ withSearch: true });

export const getCanonicalUrl = () => {
  const canonicalUrl = queryString.stringifyUrl({
    url: `${ window.location.origin }${ window.location.pathname }`
  });
  return canonicalUrl;
};

export const appliedFilter = ({ t, clearFilter, clearFilterIconId }) => {
  if (!filterIsApplied({ withSearch: true })) return null;
  return (
    <div className={ classes.appliedFilterContainer } data-testid="applied-filter-container">
      <ExpandedText className={ classes.filterStringContainer } ellipsis limit={ 2 }>
        <span className={ classes.filterString }>{generateFilterString(t)}</span>
      </ExpandedText>
      <button className={ classes.clearFilterButton } type="button" onClick={ clearFilter } data-testid="clear-filter-button">
        <SvgIcon className={ classes.clearFilterImg } id={ clearFilterIconId } size={ 25 } />
        { t('filter.clear')}
      </button>
    </div>
  );
};

export const needLoadAdvisors = ({
  needRefresh, advisors, userId, prevUserId, loading, needReloadSearchResults
}) => needRefresh || needReloadSearchResults || ((advisors.length <= 0 || userId !== prevUserId.props.value) && !loading);
